// @ts-nocheck
import React, { Component } from 'react';
import { Container, Row, Button, FormGroup } from 'reactstrap';
import AlertAPI from './AlertApi';
import { msalApp, aquireToken, LOGIN_SCOPES } from './Auth-utils';
import { fetchApi, fetchApiAnonymous } from './WebApi-utils';

class File extends React.Component {
  state = {
    variant: '',
    alertText: '',
    showAlert: false,
  };

  async componentDidMount() {
    console.log('Start File Download');

    var fileId = this.props.location.state.id;
    var fileName = this.props.location.state.name;

    this.setState({
      showAlert: true,
      variant: 'info',
      alertText: 'Attempting login.',
    });

    //Try Everyone
    const apiResponse = fetchApiAnonymous(
      process.env.REACT_APP_API_URL,
      fileId
    );

    apiResponse
      .then(async (response) => {
        const statusCode = response.status;
        console.log('staus: ' + statusCode);

        if (statusCode == 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          this.setState({
            showAlert: true,
            variant: 'success',
            alertText: 'File downloaded!',
          });
        } else {
          console.log('Error fetchApi: ' + statusCode);
          this.setState({
            showAlert: true,
            variant: 'danger',
            alertText: 'Error fetchApi: ' + statusCode,
          });
        }
      })
      .catch(async (error) => {
        console.log('Get document failure: ' + error.message);
        this.setState({
          showAlert: true,
          variant: 'danger',
          alertText: 'Get document failure: ' + error.message,
        });

        if (error.message === 'Network Error') return;

        if (error.response.status == 401) {
          this.setState({
            showAlert: true,
            variant: 'info',
            alertText: 'Attempting login.',
          });

          // Authenticated
          msalApp
            .loginPopup({ scopes: LOGIN_SCOPES })
            .then((loginResponse) => {
              console.log('Login response = ', loginResponse);

              aquireToken()
                .then((tokenResponse) => {
                  const apiResponse = fetchApi(
                    process.env.REACT_APP_API_URL,
                    fileId,
                    tokenResponse.accessToken
                  );

                  apiResponse
                    .then(async (response) => {
                      const statusCode = response.status;
                      console.log('staus: ' + statusCode);

                      if (statusCode == 200) {
                        const url = window.URL.createObjectURL(
                          new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        this.setState({
                          showAlert: true,
                          variant: 'success',
                          alertText: 'File downloaded!',
                        });
                      } else {
                        console.log('Error fetchApi: ' + statusCode);
                        this.setState({
                          showAlert: true,
                          variant: 'danger',
                          alertText: 'Error fetchApi: ' + statusCode,
                        });
                      }
                    })
                    .catch(async (error) => {
                      console.log('Get document failure: ' + error.message);
                      this.setState({
                        showAlert: true,
                        variant: 'danger',
                        alertText: 'Get document failure: ' + error.message,
                      });
                    })
                    .finally(function () {
                      // always executed
                    });
                })
                .catch(async (error) => {
                  console.log('Aquiretoken failure: ' + error.message);
                  this.setState({
                    showAlert: true,
                    variant: 'danger',
                    alertText: 'Aquiretoken failure: ' + error.message,
                  });
                })
                .finally(function () {
                  // always executed
                });
            })
            .catch(async (error) => {
              console.log('Login popup failure: ' + error.message);
              this.setState({
                showAlert: true,
                variant: 'danger',
                alertText: 'Login popup failure: ' + error.message,
              });
            })
            .finally(function () {
              // always executed
            });
        }
      })
      .finally(function () {
        // always executed
      });
  }

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <Container>
          <div style={this.state.showAlert ? {} : { display: 'none' }}>
            <AlertAPI
              variant={this.state.variant}
              text={this.state.alertText}
            />
          </div>
        </Container>
      </div>
    );
  }
}

export default File;
